import styled from "styled-components";

export const PageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 2rem;
  margin-top: 2rem;
`;
export const PageLeft = styled.div`
  width: 285px;
  flex-shrink: 0;
  position: sticky;
  top: 16px;
  margin-bottom: 8px;
  height: max-content;
  .appendTop16 {
    margin-top: 1.6rem;
  }
`;
export const PageRight = styled.div`
  width: 892px;
  flex-shrink: 0;
  position: relative;
`;

export const Wrapper = styled.div`
  background-color: #eef4fd;
`;


